import { DialogActions } from '@mui/material';
import PrimaryButton from '../../../../components/buttons/PrimaryButton';
import SecondaryButton from '../../../../components/buttons/SecondaryButton';

interface AddAgencyOfficialDialogActionsProps {
  onClose: () => void;
  padding: string;
  canContinue: boolean;
  loading: boolean;
}

const AddAgencyOfficialDialogActions = ({
  onClose,
  padding,
  canContinue,
  loading
}: AddAgencyOfficialDialogActionsProps) => {
  return (
    <DialogActions sx={{ padding }}>
      <SecondaryButton action={onClose}>Cancel</SecondaryButton>
      <PrimaryButton
        type="submit"
        loading={loading}
        disabled={!canContinue}
        minHeight="2.25rem"
        minWidth="7rem"
      >
        Continue
      </PrimaryButton>
    </DialogActions>
  );
};

export default AddAgencyOfficialDialogActions;
